import React from "react";
import { TextField } from "@material-ui/core";
import { useField } from "formik";

const DateTimePicker = ({ name, label, ...otherProps }) => {
  const [field, meta] = useField(name);

  const configDateTimePicker = {
    ...field,
    ...otherProps,
    type: "date",
    variant: "outlined",
    fullWidth: true,
    InputLabelProps: {
      shrink: true,
    },
  };

  if (meta && meta.touched && meta.error) {
    configDateTimePicker.error = true;
    configDateTimePicker.helperText = meta.error;
  }

  return (
    <>
      <label htmlFor={name} className="datelabel">
        {label}
      </label>
      <br />
      <TextField {...configDateTimePicker} />
    </>
  );
};

export default DateTimePicker;
